import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { SVGICON } from "../../../constant/theme";
import { delete_Record, errorMessage } from "../CommonFunctions";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { post, get } from "../../../helpers/api_helper";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomMultiSelect from "../../../CustomControls/CustomMultiSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";

import moment from "moment";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";
import {
  POST_GetTCAllocationList,
  POST_TCAllocationExport,
  POST_GetCustomerDDLListAJAX,
  POST_GetCustomerProjectList,
  POST_GetDepartmentDropDownList,
  POST_GetMaterialTypeDDLListByDepartment_ProductGroup,
  POST_GetTestMethodDropDownList,
  POST_ProductGroupDropDownListByDepartmentID,
  POST_DDLGetTestMasterByCompanyID,
  POST_TCAllocationDelete,
} from "../../../helpers/url_helper";
import { useFilter } from "../../../../context/FilterContext";

const TC_TestAllocation = () => {
  const [showFilter, setShowFilter] = useState(false);
  const { filter, updateFilter } = useFilter();
  const [isLoading, setIsLoading] = useState(false);

  const [customerProjectOptions, setCustomerProjectOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [productGroupOptions, setProductGroupOptions] = useState([]);
  const [materialTypeOptions, setMaterialTypeOptions] = useState([]);
  const [testOptions, setTestOptions] = useState([]);
  const [testMethodOptions, setTestMethodOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "tc-test-allocation-list"
      ? filter?.CurrentPage
      : 1,
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "tc-test-allocation-list" ? filter?.PageSize : 10,
  );
  const [recordCount, setRecordCount] = useState(0);

  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "tc-test-allocation-list" ? filter?.sortBy : "",
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "tc-test-allocation-list"
      ? filter?.orderBy
      : "asc",
  );

  const [isReset, setIsReset] = useState(false);

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      InwardNo:
        filter && filter?.page == "tc-test-allocation-list"
          ? filter?.InwardNo
          : "",
      FromDate:
        filter && filter?.page == "tc-test-allocation-list"
          ? filter?.FromDate
          : new Date(),
      ToDate:
        filter && filter?.page == "tc-test-allocation-list"
          ? filter?.ToDate
          : new Date(),
      CustomerIDEncrypted:
        filter && filter?.page == "tc-test-allocation-list"
          ? filter?.CustomerIDEncrypted
          : "",
      CustomerName:
        filter && filter?.page == "tc-test-allocation-list"
          ? filter?.CustomerName
          : "",
      CustomerProjectIDEncrypted:
        filter && filter?.page == "tc-test-allocation-list"
          ? filter?.CustomerProjectIDEncrypted
          : "",
      ProjectDetails:
        filter && filter?.page == "tc-test-allocation-list"
          ? filter?.ProjectDetails
          : "",
      LetterRefNo:
        filter && filter?.page == "tc-test-allocation-list"
          ? filter?.LetterRefNo
          : "",

      Status:
        filter && filter?.page == "tc-test-allocation-list"
          ? filter?.Status
          : "",
      TCNo:
        filter && filter?.page == "tc-test-allocation-list" ? filter?.TCNo : "",
      SampleDetail:
        filter && filter?.page == "tc-test-allocation-list"
          ? filter?.SampleDetail
          : "",
      ULRNo:
        filter && filter?.page == "tc-test-allocation-list"
          ? filter?.ULRNo
          : "",
      DepartmentIDEncrypted:
        filter && filter?.page == "tc-test-allocation-list"
          ? filter?.DepartmentIDEncrypted
          : "",
      ProductGroupIDEncrypted:
        filter && filter?.page == "tc-test-allocation-list"
          ? filter?.ProductGroupIDEncrypted
          : "",
      MaterialTypeIDEncrypted:
        filter && filter?.page == "tc-test-allocation-list"
          ? filter?.MaterialTypeIDEncrypted
          : "",
      TestMasterIDEncrypted:
        filter && filter?.page == "tc-test-allocation-list"
          ? filter?.TestMasterIDEncrypted
          : "",
      TestMethodIDEncrypted:
        filter && filter?.page == "tc-test-allocation-list"
          ? filter?.TestMethodIDEncrypted
          : "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitFilter,
    values: {
      InwardNo,
      FromDate,
      ToDate,
      CustomerIDEncrypted,
      CustomerName,
      CustomerProjectIDEncrypted,
      ProjectDetails,
      LetterRefNo,
      Status,
      TCNo,
      SampleDetail,
      ULRNo,
      DepartmentIDEncrypted,
      ProductGroupIDEncrypted,
      MaterialTypeIDEncrypted,
      TestMasterIDEncrypted,
      TestMethodIDEncrypted,
    },
  } = formikFilter;

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  const validationSchema = Yup.object().shape({});

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      tcAllocationList: [],
      TotalInward: 0,
      TotalAllocated: 0,
      TotalPending: 0,
      TotalDraft: 0,
      TotalRejectedAndRectify: 0,
      TotalInwardApproved: 0,
      TotalInwardRejected: 0,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: {
      tcAllocationList,
      TotalInward,
      TotalAllocated,
      TotalPending,
      TotalDraft,
      TotalRejectedAndRectify,
      TotalInwardApproved,
      TotalInwardRejected,
    },
  } = formik;

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      InwardNo: "",
      FromDate: new Date(),
      ToDate: new Date(),
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      ProjectDetails: "",
      LetterRefNo: "",
      Status: "",
      TCNo: "",
      SampleDetail: "",
      ULRNo: "",
      DepartmentIDEncrypted: "",
      ProductGroupIDEncrypted: "",
      MaterialTypeIDEncrypted: "",
      TestMasterIDEncrypted: "",
      TestMethodIDEncrypted: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "tc-test-allocation-list",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      InwardNo: InwardNo,
      FromDate: FromDate ? FromDate : "",
      ToDate: ToDate ? ToDate : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      CustomerName: CustomerName,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
      ProjectDetails: ProjectDetails,
      LetterRefNo: LetterRefNo,
      Status: Status,
      TCNo: TCNo,
      SampleDetail: SampleDetail,
      ULRNo: ULRNo,
      DepartmentIDEncrypted: DepartmentIDEncrypted,
      ProductGroupIDEncrypted: ProductGroupIDEncrypted,
      MaterialTypeIDEncrypted: MaterialTypeIDEncrypted,
      TestMasterIDEncrypted: TestMasterIDEncrypted,
      TestMethodIDEncrypted: TestMethodIDEncrypted,
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: "",
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      InwardNo: InwardNo,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
      ProjectDetails: ProjectDetails,
      LetterRefNo: LetterRefNo,
      Status: Array.from(Status, (x) => x.value).join(","),
      TCNo: TCNo,
      SampleDetail: SampleDetail,
      ULRNo: ULRNo,
      DepartmentIDEncrypted: DepartmentIDEncrypted,
      ProductGroupIDEncrypted: ProductGroupIDEncrypted,
      MaterialTypeIDEncrypted: MaterialTypeIDEncrypted,
      TestMasterIDEncrypted: TestMasterIDEncrypted,
      TestMethodIDEncrypted: TestMethodIDEncrypted,
    };

    //

    await post(POST_GetTCAllocationList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);

        formik.setValues({
          tcAllocationList: response?.List,
          TotalInward: response?.TotalInward,
          TotalAllocated: response?.TotalAllocated,
          TotalPending: response?.TotalPending,
          TotalDraft: response?.TotalDraft,
          TotalRejectedAndRectify: response?.TotalRejectedAndRectify,
          TotalInwardApproved: response?.TotalInwardApproved,
          TotalInwardRejected: response?.TotalInwardRejected,
        });

        setIsLoading(false);
        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getDepartmentDDL();
    getTestDDL();
    // getTestMethodDDL();
    getStatusDDL();
  }, []);

  useEffect(() => {
    getData(currentPage, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const getStatusDDL = () => {
    if (
      AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
      AuthUser?.Permissions?.InwardApprovalRequired == true
    ) {
      setStatusOptions([
        { label: "TC No Allocation Pending", value: 2 },
        { label: "TC No Allocation Draft", value: 3 },
        { label: "TC No Allocated", value: 4 },
        { label: "Inward Approved", value: 5 },
        { label: "Inward Revise & Rectify", value: 6 },
        { label: "Inward Rejected", value: 7 },
      ]);
    } else {
      setStatusOptions([
        { label: "TC No Allocation Pending", value: 2 },
        { label: "TC No Allocation Draft", value: 3 },
        // { label: "TC No Allocated", value: 4 },
        { label: "Inward Completed", value: 5 },
        // { label: "Inward Revise & Rectify", value: 6 },
        // { label: "Inward Rejected", value: 7 },
      ]);
    }
  };

  const getCustomerDDL_AJAX = (inputValue) => {
    return post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  const loadOptionsCutomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const getCustomerProjectDDL = async (customerID) => {
    setIsLoading(true);
    await post(POST_GetCustomerProjectList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypt: customerID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerProjectOptions(
            response?.CustomerProjectDDLList?.map((item) => ({
              label: item.ProjectName,
              value: item.CustomerProjectIDEncrypt,
            })),
          );
          if (
            response?.CustomerProjectDDLList?.length > 0 &&
            CustomerProjectIDEncrypted &&
            response?.CustomerProjectDDLList?.filter(
              (x) => x.CustomerProjectIDEncrypt == CustomerProjectIDEncrypted,
            ).length == 0
          ) {
            formikFilter.setFieldValue("CustomerProjectIDEncrypted", "");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (CustomerIDEncrypted) {
      getCustomerProjectDDL(CustomerIDEncrypted);
    } else {
      setCustomerProjectOptions([]);
      formikFilter.setFieldValue("CustomerProjectIDEncrypted", "");
    }
  }, [CustomerIDEncrypted]);

  //Based on logged user. Admin will see all dept. Normal user will see only own dept
  const getDepartmentDDL = async () => {
    setIsLoading(true);
    await post(POST_GetDepartmentDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setDepartmentOptions(
            response?.List?.map((item) => ({
              label: item.DepartmentName,
              value: item.DepartmentIDEncrypted,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getProductGroupDDL = async (departmentID) => {
    setIsLoading(true);
    await post(POST_ProductGroupDropDownListByDepartmentID, {
      DepartmentIDEncrypt: departmentID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setProductGroupOptions(
            response?.ProductGroupDropDownList?.map((item) => ({
              label: item.ProductGroupName,
              value: item.ProductGroupIDEncrypt,
            })),
          );
          if (
            response?.ProductGroupDropDownList?.length > 0 &&
            ProductGroupIDEncrypted &&
            response?.ProductGroupDropDownList?.filter(
              (x) => x.ProductGroupIDEncrypt == ProductGroupIDEncrypted,
            ).length == 0
          ) {
            formikFilter.setFieldValue("ProductGroupIDEncrypted", "");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (DepartmentIDEncrypted) {
      getProductGroupDDL(DepartmentIDEncrypted);
    } else {
      setProductGroupOptions([]);
      formikFilter.setFieldValue("ProductGroupIDEncrypted", "");
    }
  }, [DepartmentIDEncrypted]);

  const getMaterialTypeDDL = async (departmentID, productGroupID) => {
    setIsLoading(true);
    await post(POST_GetMaterialTypeDDLListByDepartment_ProductGroup, {
      DepartmentIDEncrypted: departmentID,
      ProductGroupIDEncrypted: productGroupID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setMaterialTypeOptions(
            response?.MaterialTypeList?.map((item) => ({
              label: item.MaterialTypeName,
              value: item.MaterialTypeIDEncrypted,
            })),
          );
          if (
            response?.MaterialTypeList?.length > 0 &&
            MaterialTypeIDEncrypted &&
            response?.MaterialTypeList?.filter(
              (x) => x.MaterialTypeIDEncrypted == MaterialTypeIDEncrypted,
            ).length == 0
          ) {
            formikFilter.setFieldValue("MaterialTypeIDEncrypted", "");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (DepartmentIDEncrypted && ProductGroupIDEncrypted) {
      getMaterialTypeDDL(DepartmentIDEncrypted, ProductGroupIDEncrypted);
    } else {
      setMaterialTypeOptions([]);
      formikFilter.setFieldValue("MaterialTypeIDEncrypted", "");
    }
  }, [ProductGroupIDEncrypted]);

  const getTestDDL = async () => {
    setIsLoading(true);
    await post(POST_DDLGetTestMasterByCompanyID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TestType: 1, // 0 - All, 1 - DT, 2 - NDT
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTestOptions(
            response?.List?.map((item) => ({
              label: item.TestName,
              value: item.TestMasterIDEncrypted,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // const getTestMethodDDL = async () => {
  //   setIsLoading(true);
  //   await post(POST_GetTestMethodDropDownList, {
  //     CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //   })
  //     .then((response) => {
  //       if (response.IsSuccess) {
  //         setTestMethodOptions(
  //           response.TestMethodList.map((item) => ({
  //             label: item.TestMethod,
  //             value: item.TestMethodIDEncrypted,
  //           }))
  //         );
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  // const exportReport = () => {
  //   setIsLoading(true);
  //   let payload = {
  //     Search: "",
  //     InwardStatus: Status,
  //     CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //     BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
  //   };
  //   post(POST_TCAllocationExport, payload)
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         window.open(response?.FilePath);
  //       } else {
  //         errorMessage(response?.Message);
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="table-responsive active-projects style-1 shorting">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">TC / Test Allocation</h4>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getResetData();
                  }}
                >
                  <i className="fa fa-window-restore" aria-hidden="true"></i>{" "}
                  Reset
                </button>
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getData();
                  }}
                >
                  <i className="fa-solid fa-refresh me-2"></i> Reload
                </button>
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <i className="fa-solid fa-filter me-2"></i>Filter
                </button>
                {/* <Link
                  className="btn btn-primary light btn-sm me-2"
                  onClick={exportReport}
                >
                  <i className="fa-solid fa-file-excel" /> Export Report
                </Link> */}
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0 pb-0">
              {showFilter ? (
                <div>
                  <FormikProvider value={formikFilter}>
                    <Form onSubmit={formikFilter.handleSubmit}>
                      <Row className="me-0">
                        <Col lg={3}>
                          <Field
                            label="Inward No"
                            name="InwardNo"
                            placeholder={"Search Inward No"}
                            component={CustomInput}
                          />
                        </Col>
                        <Col lg={3}>
                          <label>Inward Date</label>
                          <div className="d-flex">
                            <Field
                              name="FromDate"
                              placeholder={"From Date"}
                              component={CustomFlatpickr}
                              options={{
                                altInput: true,
                                altFormat: "j-M-Y",
                                dateFormat: "d-m-Y",
                              }}
                            />
                            <div>&nbsp;</div>
                            <Field
                              name="ToDate"
                              placeholder={"To Date"}
                              component={CustomFlatpickr}
                              options={{
                                altInput: true,
                                altFormat: "j-M-Y",
                                dateFormat: "d-m-Y",
                                minDate: FromDate,
                              }}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Customer"
                            name="CustomerIDEncrypted"
                            placeholder={"Select Customer"}
                            loadOptionsFn={loadOptionsCutomer}
                            component={CustomSelectAsync}
                            title={CustomerName}
                            labelFieldName="CustomerName"
                            //menuPosition="fixed"
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Project"
                            name="CustomerProjectIDEncrypted"
                            placeholder={"Select Project"}
                            options={customerProjectOptions}
                            component={CustomSelect}
                            menuPosition="fixed"
                            menuStyles={{
                              position: "absolute",
                              right: 0,
                            }}
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Work Detail"
                            name="ProjectDetails"
                            placeholder={"Search Work Detail"}
                            component={CustomInput}
                            maxLength={2000}
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Letter Ref No"
                            name="LetterRefNo"
                            placeholder={"Search Letter Ref No"}
                            component={CustomInput}
                          />
                        </Col>

                        <Col lg={6}>
                          <Field
                            label="Status"
                            name="Status"
                            placeholder={"Select Status"}
                            options={statusOptions}
                            component={CustomMultiSelect}
                            isMulti={true}
                            menuPosition="fixed"
                          />
                        </Col>
                      </Row>
                      <hr className="mt-1 mb-1"></hr>
                      <Row className="me-0">
                        <Col lg={3}>
                          <Field
                            label="TC No"
                            name="TCNo"
                            placeholder={"Search TC No"}
                            component={CustomInput}
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Sample Name"
                            name="SampleDetail"
                            placeholder={"Search Sample Name"}
                            component={CustomInput}
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="ULR No"
                            name="ULRNo"
                            placeholder={"Search ULR No"}
                            component={CustomInput}
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Department"
                            name="DepartmentIDEncrypted"
                            placeholder={"Select Department"}
                            options={departmentOptions}
                            component={CustomSelect}
                            menuPosition="fixed"
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Material Group"
                            name="ProductGroupIDEncrypted"
                            placeholder={"Select Material Group"}
                            options={productGroupOptions}
                            component={CustomSelect}
                            menuPosition="fixed"
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Material Type"
                            name="MaterialTypeIDEncrypted"
                            placeholder={"Select Material Type"}
                            options={materialTypeOptions}
                            component={CustomSelect}
                            menuPosition="fixed"
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Test"
                            name="TestMasterIDEncrypted"
                            placeholder={"Select Test"}
                            options={testOptions}
                            component={CustomSelect}
                            menuPosition="fixed"
                          />
                        </Col>
                        <Col lg={3}>
                          {/* <Field
                            label="Test Method"
                            name="TestMethodIDEncrypted"
                            placeholder={"Select Test Method"}
                            options={testMethodOptions}
                            component={CustomSelect}
                            menuPosition="fixed"
                          /> */}
                          <div className="mb-2">
                            <label className="mb-1">&nbsp;</label>
                            <div>
                              <button
                                type="button"
                                // className="btn btn-primary btn-sm mb-1"
                                className="btn btn-primary btn-sm mb-1 me-2"
                                onClick={(e) => {
                                  getData();
                                }}
                              >
                                <i
                                  className="fa fa-search"
                                  aria-hidden="true"
                                ></i>{" "}
                                Search
                              </button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </FormikProvider>
                </div>
              ) : (
                ""
              )}
              <div className="d-flex">
                <div style={{ width: showFilter ? "93%" : "100%" }}>
                  {/* <Row>
                    <Col lg={2}>
                      <label className="mt-1">
                        Inward : &nbsp; {TotalInward}
                      </label>
                    </Col>
                    <Col lg={2}>
                      <label className="mt-1">
                        Allocated : &nbsp; {TotalAllocated}
                      </label>
                    </Col>
                    <Col lg={2}>
                      <label className="mt-1">
                        Pending : &nbsp; {TotalPending}
                      </label>
                    </Col>
                    <Col lg={2}>
                      <label className="mt-1">
                        Draft : &nbsp; {TotalDraft}
                      </label>
                    </Col>
                    <Col lg={2}>
                      <label className="mt-1">
                        Approved : &nbsp; {TotalInwardApproved}
                      </label>
                    </Col>
                    <Col lg={2}>
                      <label className="mt-1">
                        Revise & Rectify : &nbsp; {TotalRejectedAndRectify}
                      </label>
                    </Col>
                    <Col lg={2}>
                      <label className="mt-0">
                        Rejected : &nbsp; {TotalInwardRejected}
                      </label>
                    </Col>
                  </Row> */}
                  <div className="bootstrap-badge pt-2">
                    <label
                      className="me-1 badge-primary badge p-1"
                      style={{ color: "#ffffff", minWidth: "100px" }}
                    >
                      Inward : {TotalInward}
                    </label>
                    {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                    AuthUser?.Permissions?.InwardApprovalRequired == true ? (
                      <label
                        className="me-1 badge p-1"
                        style={{
                          color: "#ffffff",
                          backgroundColor: "#0D99FF",
                          minWidth: "100px",
                        }}
                      >
                        Allocated : {TotalAllocated}
                      </label>
                    ) : (
                      ""
                    )}
                    <label
                      className="me-1 badge-dark badge p-1 "
                      style={{ color: "#ffffff", minWidth: "100px" }}
                    >
                      Pending : {TotalPending}
                    </label>
                    <label
                      className="me-1 badge-info badge p-1"
                      style={{ color: "#ffffff", minWidth: "100px" }}
                    >
                      Draft : {TotalDraft}
                    </label>
                    <label
                      className="me-1 badge-success badge p-1 "
                      style={{ color: "#ffffff", minWidth: "100px" }}
                    >
                      {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                      AuthUser?.Permissions?.InwardApprovalRequired == true
                        ? "Approved :"
                        : "Completed :"}{" "}
                      {TotalInwardApproved}
                    </label>
                    {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                    AuthUser?.Permissions?.InwardApprovalRequired == true ? (
                      <>
                        <label
                          className="me-1 badge-warning badge p-1 "
                          style={{ color: "#ffffff", minWidth: "100px" }}
                        >
                          Revise & Rectify : {TotalRejectedAndRectify}
                        </label>
                        <label
                          className="me-1 badge-danger badge p-1 "
                          style={{ color: "#ffffff", minWidth: "100px" }}
                        >
                          Rejected : {TotalInwardRejected}
                        </label>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {/* {showFilter && (
                  <div style={{ width: "7%" }}>
                    <button
                      type="button"
                      // className="btn btn-primary btn-sm mb-1"
                      className="btn btn-outline-primary btn-sm mb-1"
                      onClick={(e) => {
                        getData();
                      }}
                    >
                      <i className="fa fa-search" aria-hidden="true"></i> Search
                    </button>
                  </div>
                )} */}
              </div>
              <div
                id="tcAllocation-tbl_wrapper"
                className="dataTables_wrapper no-footer mt-1"
              >
                <table
                  id="tcAllocation-tbl"
                  className="table dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th width="7%"></th>
                      <th
                        style={{
                          width: "14%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("InwardNo");
                        }}
                      >
                        Inward No
                        <span className="ml-1">
                          {sortBy == "InwardNo" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "12%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("InwardDate");
                        }}
                      >
                        Inward Date
                        <span className="ml-1">
                          {sortBy == "InwardDate" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "17%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("InwardStatus");
                        }}
                      >
                        Inward Status
                        <span className="ml-1">
                          {sortBy == "InwardStatus" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "25%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("CustomerName");
                        }}
                      >
                        Customer
                        <span className="ml-1">
                          {sortBy == "CustomerName" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "25%",
                          cursor: "pointer",
                          textAlign: "left",
                        }}
                        onClick={() => {
                          handleClickSorting("ProjectName");
                        }}
                      >
                        Project
                        <span className="ml-1">
                          {sortBy == "ProjectName" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      {/* <th
                        style={{
                          width: "15%",
                          cursor: "pointer",
                          textAlign: "left",
                        }}
                        onClick={() => {
                          handleClickSorting("TCNo");
                        }}
                      >
                        TC No
                        <span className="ml-1">
                          {sortBy == "TCNo" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {tcAllocationList?.length > 0 ? (
                      tcAllocationList?.map((item, indx) => (
                        <React.Fragment key={indx}>
                          <tr key={indx}>
                            <td
                              style={{
                                verticalAlign: "top",
                                whiteSpace: "normal",
                              }}
                              className={
                                item.TCNos ? "border-bottom-0 pb-0" : ""
                              }
                              rowSpan={item.TCNos ? 2 : 1}
                            >
                              {item.InwardCurrentStatus == 2 ||
                              item.InwardCurrentStatus == 3 ||
                              item.InwardCurrentStatus == 4 ||
                              item.InwardCurrentStatus == 6 ? (
                                <>
                                  {AuthUser?.UserType !== 1 ||
                                  formsList?.filter(
                                    (x) => x?.FormID == 32 && x?.IsEdit,
                                  )?.length > 0 ? (
                                    <Link
                                      to={
                                        item.IsHold == true
                                          ? "#"
                                          : `/tc-test-allocation/${window.btoa(
                                              item.InwardIDEncrypted,
                                            )}`
                                      }
                                      // className="icon-box icon-box-md bg-primary-light me-1"
                                      className="icon-box icon-box-md me-1"
                                      title="TC Allocation"
                                      disabled={item.IsHold}
                                    >
                                      {SVGICON.EditPrimary}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                </>
                              ) : (
                                ""
                              )}
                              {item?.InwardCurrentStatus >= 5 &&
                              item?.InwardCurrentStatus != 6 ? (
                                <>
                                  {(AuthUser?.UserType !== 1 ||
                                    AuthUser?.Permissions?.IsInwardApprover) &&
                                  AuthUser?.Permissions?.ApprovalWorkflow ==
                                    1 &&
                                  AuthUser?.Permissions
                                    ?.InwardApprovalRequired == true ? (
                                    <Link
                                      to={
                                        item.IsHold == true
                                          ? "#"
                                          : `/add-inward-approval/${window.btoa(
                                              item.InwardIDEncrypted,
                                            )}`
                                      }
                                      // className="icon-box icon-box-md bg-primary-light me-1"
                                      className="icon-box icon-box-md me-1"
                                      title="Inward Approval"
                                      disabled={item.IsHold}
                                    >
                                      {SVGICON.Verified}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                </>
                              ) : (
                                <>
                                  {item?.InwardCurrentStatus == 4 &&
                                  (AuthUser?.UserType !== 1 ||
                                    AuthUser?.Permissions?.IsInwardApprover) &&
                                  AuthUser?.Permissions?.ApprovalWorkflow ==
                                    1 &&
                                  AuthUser?.Permissions
                                    ?.InwardApprovalRequired == true ? (
                                    <Link
                                      to={
                                        item.IsHold == true
                                          ? "#"
                                          : `/add-inward-approval/${window.btoa(
                                              item.InwardIDEncrypted,
                                            )}`
                                      }
                                      // className="icon-box icon-box-md bg-primary-light me-1"
                                      className="icon-box icon-box-md me-1"
                                      title="Inward Approval"
                                      disabled={item.IsHold}
                                    >
                                      {SVGICON.Unverified}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                </>
                              )}
                              {item?.InwardCurrentStatus > 2 &&
                              (AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 32 && x?.IsDelete,
                                )?.length > 0) ? (
                                <Link
                                  to="#"
                                  // className="icon-box icon-box-md bg-danger-light me-1"
                                  className="icon-box icon-box-md"
                                  title="Delete"
                                  onClick={() => {
                                    if (item.IsHold == false) {
                                      delete_Record(
                                        POST_TCAllocationDelete,
                                        {
                                          InwardIDEncrypted:
                                            item?.InwardIDEncrypted,
                                          ModifiedByEncrypted:
                                            AuthUser?.ReferenceIDEncrypt
                                              ? AuthUser?.ReferenceIDEncrypt
                                              : "0",
                                        },
                                        setIsLoading,
                                        fnCallback,
                                        item.InwardNo,
                                      );
                                    }
                                  }}
                                  disabled={item.IsHold}
                                >
                                  {SVGICON.DeleteDanger}
                                </Link>
                              ) : (
                                ""
                              )}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                // verticalAlign: "top",
                              }}
                              // className={
                              //   item.TCNos ? "border-bottom-0 pb-0" : ""
                              // }
                            >
                              {item.InwardNo}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                // verticalAlign: "top",
                              }}
                              // className={
                              //   item.TCNos ? "border-bottom-0 pb-0" : ""
                              // }
                            >
                              {item.InwardDate}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                // verticalAlign: "top",
                              }}
                              // className={
                              //   item.TCNos ? "border-bottom-0 pb-0" : ""
                              // }
                            >
                              {item.InwardStatus}
                              {item.InwardCurrentStatus == 6 ? (
                                <>
                                  &nbsp;
                                  <OverlayTrigger
                                    trigger={["hover", "focus"]}
                                    key={indx}
                                    responsive={true}
                                    overlay={
                                      <Tooltip
                                        className="toltip-popover"
                                        // id={`popover-positioned-${item.InwardRejectRectifyReason.toLowerCase()}`}
                                      >
                                        <strong className="p-1">
                                          {item.InwardRejectRectifyReason}
                                          <br></br>
                                          {item.InwardRejectRectifyBy}
                                          {" - "}
                                          {item.InwardRejectRectifyDate}
                                        </strong>
                                      </Tooltip>
                                    }
                                  >
                                    <span>
                                      <i
                                        className="fa fa-question-circle"
                                        style={{ cursor: "pointer" }}
                                      ></i>
                                    </span>
                                  </OverlayTrigger>
                                </>
                              ) : (
                                ""
                              )}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                // verticalAlign: "top",
                              }}
                              // className={
                              //   item.TCNos ? "border-bottom-0 pb-0" : ""
                              // }
                            >
                              {item.CustomerName}
                            </td>
                            <td
                              style={{
                                textAlign: "left",
                                whiteSpace: "normal",
                                // verticalAlign: "top",
                              }}
                              // className={
                              //   item.TCNos ? "border-bottom-0 pb-0" : ""
                              // }
                            >
                              {item.ProjectName}
                            </td>
                            {/* <td
                              style={{
                                textAlign: "left",
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {item.TCNos}
                            </td> */}
                          </tr>
                          {item.TCNos ? (
                            <tr key={`${indx}.1`}>
                              {/* <td></td> */}
                              <td
                                colSpan={7}
                                style={{
                                  textAlign: "left",
                                  // verticalAlign: "top",
                                  whiteSpace: "normal",
                                }}
                                // className="p-0"
                              >
                                {/* <table className="table dataTable no-footer mb-0">
                                  <tbody>
                                    <tr style={{ cursor: "pointer" }}>
                                      <td
                                        style={{
                                          whiteSpace: "normal",
                                          verticalAlign: "top",
                                        }}
                                        className="border-bottom-0 pt-1 pb-0"
                                      > */}
                                <div className="d-flex">
                                  <label
                                    className="text-secondary mb-1"
                                    style={{
                                      textAlign: "left",
                                      minWidth: "45px",
                                    }}
                                  >
                                    TC No : &nbsp;
                                  </label>
                                  <div style={{ textAlign: "left" }}>
                                    {item.TCNos}
                                  </div>
                                </div>
                                {/* </td>
                                    </tr>
                                  </tbody>
                                </table> */}
                              </td>
                            </tr>
                          ) : (
                            ""
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={7} style={{ textAlign: "left" }}>
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="d-sm-flex text-center justify-content-between align-items-center">
                  <CustomSizePerPage
                    getData={getData}
                    currentSizePerPage={currentSizePerPage}
                  />
                  <div className="dataTables_info">
                    Showing{" "}
                    {recordCount > 0
                      ? (currentPage - 1) * currentSizePerPage + 1
                      : 0}{" "}
                    to{" "}
                    {recordCount > currentPage * currentSizePerPage
                      ? currentPage * currentSizePerPage
                      : recordCount}{" "}
                    of {recordCount} entries
                  </div>
                  <CustomPaginationButtons
                    totalPages={recordCount / currentSizePerPage}
                    currentPage={currentPage}
                    currentSizePerPage={currentSizePerPage}
                    getData={getData}
                  />
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default TC_TestAllocation;
